var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 40.5H19.1725C19.7022 40.5002 20.2102 40.7106 20.585 41.085L25.415 45.915C25.7898 46.2894 26.2978 46.4998 26.8275 46.5H37.1725C37.7022 46.4998 38.2102 46.2894 38.585 45.915L43.415 41.085C43.7898 40.7106 44.2978 40.5002 44.8275 40.5H54M12 10.5H52C53.1046 10.5 54 11.3954 54 12.5V52.5C54 53.6046 53.1046 54.5 52 54.5H12C10.8954 54.5 10 53.6046 10 52.5V12.5C10 11.3954 10.8954 10.5 12 10.5Z",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyArchive);
export default __webpack_public_path__ + "static/media/empty-archive.f75cce7b6abc64b7b39b3be908316638.svg";
export { ForwardRef as ReactComponent };